import config from './config';
import { TRANSLATIONS_KEY, webviewParam } from './constants';

/*
    Returns the translation for the given key.
    If the translation is not found, the defaultValue is returned.
*/
export const getTranslations = (key, defaultValue) => {
  return window['translations']?.[key] || defaultValue || 'N/A';
};

export const getToken = async () => {
  try {
    let token = await window?.getAuthInfo();
    return token?.idToken;
  } catch (error) {
    console.log('err', error);
  }
};

/*
    Replaces the placeholders in the given string with the values from the given object.
 */
export const replacePlaceholder = (input, replaceObj) => {
  const pattern = /\{([^}]+)\}/g;

  function replacer(str) {
    return str.replace(pattern, (match, key) => {
      return replaceObj.hasOwnProperty(key) ? replaceObj[key] : match;
    });
  }

  if (typeof input === 'string') {
    return replacer(input);
  }

  if (Array.isArray(input)) {
    return input.map((item) => {
      if (typeof item === 'string') {
        return replacer(item);
      }
      if (typeof item === 'object' && item !== null) {
        return replacePlaceholder(item, replaceObj);
      }
      return item;
    });
  }

  if (typeof input === 'object' && input !== null) {
    return Object.keys(input).reduce((acc, key) => {
      if (typeof input[key] === 'string') {
        acc[key] = replacer(input[key]);
      } else if (typeof input[key] === 'object') {
        acc[key] = replacePlaceholder(input[key], replaceObj);
      } else {
        acc[key] = input[key];
      }
      return acc;
    }, {});
  }

  return input;
};

export const getCurrentRoute = (pathname) => {
  const routeParts = pathname.split('/');
  return routeParts[routeParts.length - 1];
};

export const serialize = (data) => {
  if (!data) return;
  return typeof data === 'string' ? data : JSON.stringify(data);
};

export const removeCookie = (name) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};

export const formatDate = (date) => {
  if (!date) return '';

  let dateObj;

  if (date instanceof Date) {
    dateObj = date;
  } else if (date.includes('T')) {
    dateObj = new Date(date);
  } else {
    const [day, month, year] = date.split('-');
    dateObj = new Date(`${year}-${month}-${day}`);
  }

  if (isNaN(dateObj)) return 'Invalid Date';

  return dateObj
    .toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    })
    .toUpperCase();
};

export const getCookie = (c_name) => {
  const cookiesArray = document.cookie.split(';');

  for (let cookie of cookiesArray) {
    const [name, value] = cookie.split('=').map((c) => c.trim());

    if (name === c_name) {
      const rawComponent = value;
      const safeComponent = encodeURIComponent(rawComponent);
      return JSON.parse(decodeURIComponent(safeComponent));
    }
  }

  return null;
};

export const deleteAllCookies = (reloadPage) => {
  const cookies = document.cookie.split(';');

  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);

  for (let cookie of cookies) {
    const cookieName = cookie.split('=')[0].trim();
    document.cookie = `${cookieName}=;expires=${yesterday.toUTCString()};domain=${config.sDomain
      };path=/`;
    document.cookie = `${cookieName}=;expires=${yesterday.toUTCString()};path=/`;
  }

  if (reloadPage) {
    window.location.reload();
  }
};

export const setCookie = (name, value, days) => {
  var expires = '';
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/';
};

export const calculateTimeRemaining = (deadLineDate) => {
  const timeLeft = new Date(deadLineDate + "Z") - new Date();
  const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
  return {
    days: days < 0 ? 0 : days,
    hours: hours < 0 ? 0 : hours,
    minutes: minutes < 0 ? 0 : minutes,
    seconds: seconds < 0 ? 0 : seconds,
    isDeadLineExpired: seconds < 0,
  }
};

export const setCacheBusterCookie = (cookieName) => {
  let curdate = new Date();
  let jYear = curdate.getUTCFullYear();
  let jMonth = curdate.getUTCMonth();
  jMonth = jMonth + 1;
  let jDate = curdate.getUTCDate();
  let jHours = curdate.getUTCHours();
  let jMInutes = curdate.getUTCMinutes();
  let jSeconds = curdate.getUTCSeconds();

  let sNowUTC =
    jYear +
    '' +
    (jMonth < 10 ? '0' + jMonth : jMonth) +
    '' +
    (jDate < 10 ? '0' + jDate : jDate) +
    '' +
    (jHours < 10 ? '0' + jHours : jHours) +
    '' +
    (jMInutes < 10 ? '0' + jMInutes : jMInutes) +
    '' +
    (jSeconds < 10 ? '0' + jSeconds : jSeconds);
  // let curtime = curdate.getTime();
  let curtime = curdate.getTime();
  curdate.setTime(curtime + 31540000000 /*(5 * 60 * 1000)*/); //added one year expiry.
  let expires = 'expires=' + curdate.toUTCString() + ';path=/';
  document.cookie = cookieName + '=' + sNowUTC + '; ' + expires + ';';
};

export const savePlayersToLocalStorage = (gameDayId, players) => {
  let storedTeams = JSON.parse(localStorage.getItem('guestTeams')) || {};

  storedTeams[gameDayId] = players;

  localStorage.setItem('guestTeams', JSON.stringify(storedTeams));
};

export const getPlayersFromLocalStorage = (gameDayId) => {
  let storedTeams = JSON.parse(localStorage.getItem('guestTeams')) || {};
  return storedTeams[gameDayId] || [];
};

export const getQueryParamsObject = () => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  return params;
};

export function isWebView() {
  return document.querySelector('[data-type="toppicksWebview"]') !== null;
}
export const updateBuster = (text) => {
  switch (text) {
    case 'team':
    case 'login':
    case 'web-login':
    case 'teamnamechange':
      setCacheBusterCookie(config.enumBusters.team);
      break;
    case 'create':
    case 'disjoin':
    case 'join':
    case 'reNameLeague':
      setCacheBusterCookie(config.enumBusters.privateContest);
      break;
    default:
  }
};
export const areArraysEqual = (arr1 = [], arr2 = []) => {
  if (arr1.length !== arr2.length) return false;
  return [...arr1].sort().join() === [...arr2].sort().join();
};
export const handleNavigation = (url) => {
  window.location.href = url;
};
